module.exports = "/_next/static/images/7c52e9188b1c8e4a53231c255e4e3697-nu-card-md@2x.jpg.webp";